<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :modifiers="`py-5`"
    >
        <template slot="card-header">
            <h1 v-translate>Forgot Password</h1>
        </template>
        <template slot="card-body">
            <div class="row justify-content-center text-size-base mb-2">
                <div class="col-md-8">
                    <p
                        class="text-standard"
                        v-translate
                    >Having trouble logging in?</p>
                    <ul class="text-list dashed">
                        <li v-translate>Usernames are in the form of an email address.</li>
                        <li v-translate>Passwords are case sensitive.</li>
                    </ul>
                    <p
                        class="text-standard"
                        v-translate
                    >To reset your password, enter your email.</p>
                </div>
            </div>
            <form
                method="POST"
                :action="$laraRoute('password.email')"
                @submit.prevent="handleForm"
                aria-label="Reset Password"
                novalidate
            >
                <div class="form-group row justify-content-center align-items-center">
                    <div class="col-md-2 col-lg-2">
                        <label
                            for="email"
                            v-translate
                        >E-Mail</label>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <Input
                            :rule="'required|email'"
                            name="email"
                            errorType="email"
                            model="email"
                            module="Auth"
                            :required="true"
                        />
                    </div>
                </div>

                <div class="form-group row mb-0 mt-4 justify-content-center">
                    <div class="col-md-3">
                        <LoaderedButton
                            type="submit"
                            btnClasses="btn btn-primary btn-full-small"
                            :content="'Send Link' | translate"
                            :isValid="isValid"
                        />
                    </div>
                </div>

                <div class="form-group row mb-0 mt-3 justify-content-center text-size-base">
                    <div class="col text-center">
                        <router-link
                            class="form__cancel"
                            to="/"
                            v-translate
                        >Cancel</router-link>
                    </div>
                </div>

            </form>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import FlashMessage from "@C/FlashMessage";
import LoaderedButton from '@C/LoaderedButton';
import Card from "@C/Card";
import Input from "@C/Forms/Input";
import validator from "@M/validationWrapper";

export default {
    name: "ForgotPassword",
    methods: {
        ...mapActions({
            formHandler: "Auth/forgotPassword"
        })
    },
    computed: {
        ...mapFields(`Auth`, ["email"])
    },
    components: {
        Card,
        Input,
        FlashMessage,
        LoaderedButton
    },
    mixins: [validator]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/ForgotPassword.vue